import { tw } from '@/utils/tw';

const Emphasis = tw.theme({});

export default Emphasis;
